module.exports = __webpack_public_path__ + "static/media/contact_support.612c5d80.png";